import { flavors } from '../../config'

export default function getPageFlavor(conferenceYear) {
  const currentYear = new Date().getFullYear()
  const year = conferenceYear ? parseInt(conferenceYear, 10) : null
  return year === currentYear ? 'seafoam' : flavors.default
}
